// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"342":"96f870aa","475":"35189946","2947":"11b01132","3716":"c5a73467"}[chunkId] + ".chunk.css";
};